import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '@mui/material/Pagination';

import * as taskRedux from '../redux/TaskRedux';
import TaskTable from './TaskTable';

function RecoveryTable() {
  const dispatch = useDispatch();
  const tasks = useSelector(taskRedux.recoveryTasksSelector);
  const count = useSelector(taskRedux.recoveryCountSelector);
  const status = useSelector(taskRedux.recoveryTasksStatusSelector);
  const page = useSelector(taskRedux.recoveryPageSelector);

  useEffect(() => {
    dispatch(taskRedux.actions.retrieveRecoveryTasks());
  }, []);

  function onPageChange(event, page) {
    dispatch(taskRedux.actions.retrieveRecoveryTasks(page));
  }

  return (
    <div className="card w-100">
      <div className="card-body position-relative" id="kt_not_reachable_body">
        <TaskTable
          tasks={tasks}
          displayOwner={false}
          onRefresh={() => dispatch(taskRedux.actions.retrieveRecoveryTasks())}
          loading={status === 'loading'}
        />
        {count > 0 && (
          <Pagination
            className="mx-auto mt-4 d-flex justify-content-center"
            count={Math.ceil(count / taskRedux.TASKS_PER_PAGE)}
            page={page}
            onChange={onPageChange}
          />
        )}
      </div>
    </div>
  );
}

export default RecoveryTable;
